<template>
  <div class="product-filter">
    <button class="btn display-filter-btn" :class="{'btn-bg-ts': brandName === Brand.Travelsphere}" @click="viewMobileFilters" aria-label="Open filter menu" title="Open filter menu">{{filterViewText}}</button>
    <div class="filter">
      <div class="filter__header" :class="{'filter__headerTs': brandName === Brand.Travelsphere}">
        <span class="filter__title" dir="ltr">{{filterText}}</span>
        <button class="filter__clear hide-mobile" :class="{'filter__clear_ts': brandName === Brand.Travelsphere}" @click="clearAllFilters" aria-label="Clear all filters" title="Clear all filters">{{filterClearText}}</button>
        <button class="filter__close" @click="hideMobileFilters" aria-label="Close filter menu" title="Close filter menu">{{filterCloseText}}</button>
      </div>
      <div class="filter__container" :class="{'filter__containerTs': brandName === Brand.Travelsphere}">
        <template v-for="(filter, filterKey) in filters">
          <component
            :is="filter.type"
            :key="filterKey"
            :filter="filter"
            :filterKey="filterKey"
            :store="store"
            :brand-name="brandName"
          ></component>
        </template>
        <div class="filter__footer">
          <button class="btn filter__save-btn" :class="{'btn-bg-ts': brandName === Brand.Travelsphere}" @click="hideMobileFilters" aria-label="Apply filters" title="Apply filters">Apply Filters</button>
          <button class="filter__clear" @click="clearAllFilters" aria-label="Clear all filters" title="Clear all filters">{{filterClearText}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex';
import FilterValue from './FilterValue.vue';
import FilterRange from './FilterRange.vue';
import EventBus from '@/vue/EventBus';
import debounce from 'lodash/debounce';
import * as accordion from '../../modules/accordion';
import {Brand} from '../../brand.js';

export default {
  name: 'Filters',

  components: {
    Value: FilterValue,
    Range: FilterRange
  },

  props: {
    store: {
      type: String,
      required: true
    },
    brandName: String,
    filterText: String,
    filterViewText: String,
    filterCloseText: String,
    filterClearText: String
  },

  computed: Vuex.mapState({
    filters(state) {
      return state[this.store].filters;
    }
  }),

  data() {
    return {
      Brand
    };
  },

  methods: {
    // clear filter button clicked
    clearAllFilters() {
      this.$store.dispatch(`${this.store}/clearAllFilters`);
      this.$store.dispatch(`${this.store}/fetchItems`);
    },

    viewMobileFilters() {
      $('html').addClass('filter-open');
      $('.filter__close').focus();
    },

    hideMobileFilters() {
      $('html').removeClass('filter-open');
      $('.display-filter-btn').focus();
    }
  },

  created() {
    // apply accordion to filters
    EventBus.$on('ITEMS_LOADED', () => {
      this.$nextTick().then(() => {
        accordion.init();
        picturefill();
      });
    });
  }
};
</script>
